<template>
  <div class="container-wrapper">
    <div class="title">
      {{title}}
    </div>
    <div class="subtitle">
      {{subtitle}}
    </div>
    <div v-for="(text, index) in content"
      :key="'content-'+index"
      class="content">
      {{text}}
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    content: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
  .container-wrapper {
    padding: 16px;
    display: inline-flex;
    flex-direction: column;
    width: calc(100% - 32px);
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    text-align: left;
    font-size: 14px;
    line-height: 20.4px;
    color: #223448;
  }

  .title {
    color: #778699;
    font-size: 12px;
    line-height: 22.4px;
    text-transform: uppercase;
    padding-bottom: 8px;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    border-bottom: 1px solid #C1CCD4;
  }

  .subtitle {
    font-weight: bold;
    margin-top: 8px;
    word-break: break-word;
  }

  .content {
    margin-top: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
